export default {"src":"/_next/static/media/icon-404.8a7b328a.svg","height":168,"width":385,"blurWidth":0,"blurHeight":0};